import { effect, inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { catchError, combineLatest, delay, filter, firstValueFrom, map, Observable, of, switchMap, take, tap } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { SafeKeyedRead } from '@angular/compiler';
import { APP_ROUTES } from '@app/core/constants/routes.constants';
import { FirebaseAuthService } from '../services/firebase-auth.service';
import { appCheckInstance$ } from '@angular/fire/app-check';
import { environment } from '@environments/environment';


export const authGuard:  CanActivateFn =   () =>  {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (environment.consoleFlag)
  console.log("inside authguard...");

  // return authService.userProfile$.pipe(
  //   filter(profile => profile !== undefined), // wait until backend finishes resolving
  //   take(1),
  //   map(profile => {
  //     if (profile) {
  //       console.log(" proifle in authguard..allow route");
  //       return true; // ✅ allow
  //     } else {
  //       console.log("No proifle in authguard..redirect to login");
  //       return router.createUrlTree([APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.SIGNIN]); // 🔴 redirect
  //     }
  //   })
  // );
  // return authService.userProfile$.pipe(
  //   // wait for resolved state
  //   filter(p => p !== undefined),
  //   take(1),
  //   map(p => (p ? true : router.createUrlTree([APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.SIGNIN])))
  // );

   return combineLatest([authService.session$, authService.userProfile$]).pipe(
    filter(([s, p]) => s !== undefined && p !== undefined), // wait until hydration
    take(1),
    map(([session, profile]) =>
      session && profile
        ? true
        : router.createUrlTree([APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.SIGNIN])
    )
  );
  
};
